/**
 * Evaluates AWS-IAM style statements to check if an action key is permitted.
 * Supports explicit Deny, wildcards '*', and matches statements in list order.
 */

export function matchesActionPattern(pattern, action) {
  if (!pattern || !action) return false

  const patternParts = pattern.split('.')
  const actionParts = action.split('.')

  for (let i = 0; i < patternParts.length; i++) {
    const pPart = patternParts[i]

    // If pattern part is a wildcard, it matches the rest of the action parts
    if (pPart === '*') {
      return true
    }

    // If action does not have this level, it is not a match
    if (i >= actionParts.length) {
      return false
    }

    // If parts don't match, return false
    if (pPart !== actionParts[i]) {
      return false
    }
  }

  // If we processed all pattern parts, they must match the action parts length
  return patternParts.length === actionParts.length
}

export function hasIamPermission(statements, actionKey) {
  // Check WFM_ADMIN first at generic helper level
  try {
    const userObj = JSON.parse(localStorage.getItem('user'))
    if (userObj) {
      const roles = userObj.role || userObj.cwRole || []
      if (roles.includes('WFM_ADMIN')) {
        return true
      }
    }
  } catch (e) {
    console.error('Error parsing user roles in hasIamPermission:', e)
  }

  if (!statements || !Array.isArray(statements)) {
    return false
  }

  let allowed = false
  let hasWildcard = false

  for (const statement of statements) {
    const effect = statement.effect ? statement.effect.toLowerCase() : ''
    const actions = statement.actions || []

    for (const pattern of actions) {
      if (effect === 'deny') {
        if (matchesActionPattern(pattern, actionKey)) {
          // Explicit deny overrides any allows immediately
          return false
        }
      } else if (effect === 'allow') {
        if (pattern === '*' || pattern === 'global.system.*' || pattern === 'global.system') {
          hasWildcard = true
        } else if (matchesActionPattern(pattern, actionKey)) {
          allowed = true
        }
      }
    }
  }

  return allowed || hasWildcard
}

export default {
  matchesActionPattern,
  hasIamPermission
}
